import React from "react";
import { Typography } from "antd";

import { StyledContent } from "styled/cpac-qc-styled";
import { translate } from "lib/helper";

const { Title } = Typography;

// เนื้อหาเริ่มห่างขอบจอ 24px แบบ SIS (main p-6) ไม่มีการ์ดครอบทั้งหน้า: การ์ดของแต่ละส่วน (filter, ตาราง, ฟอร์ม) วางบนพื้นหน้าเลย
const cssStyle = {
  margin: "0px 24px",
  padding: 0,
  minHeight: 280,
};

// หัวข้อหน้าแบบ SIS (text-xl font-bold text-slate-800 mb-5): ห่าง header 24px ชิดซ้ายเท่าเนื้อหา ห่างการ์ดแรก 20px ไม่มี breadcrumb
const titleStyle = {
  color: "var(--text-title)",
  fontWeight: 700,
  margin: "24px 24px 20px",
};

const ContentLayout = (props) => {
  let value = {
    title: "",
    menu: "",
    matching_key: "",
  };

  let currentUrl = window.location.pathname.replace(/\/\d+/g, "").split("/");
  props.children.map((x) => {
    const { path } = x.props.value;
    let rx = path.replace(/\//g, "");
    if (currentUrl[1] === rx) return (value = x.props.value);
    return false;
  });

  const { title } = value;

  return (
    <div style={{
        width:'100%',
        paddingBottom:"24px",
        background: "#f8fafc",
      }}>
      <Title level={4} style={titleStyle}>
        {currentUrl.length >= 3 && translate(currentUrl[2], "titleaction")}
        {currentUrl.length < 3 && translate(title, "sidebar")}
      </Title>
      {/* class ตาม path แรก (เช่น sis-page-qc-tracking) ให้ sis-theme.css แต่งพื้นของส่วนที่หน้านั้นไม่มีการ์ดได้ */}
      <StyledContent className={`sis-page-${currentUrl[1] || "home"}`} style={cssStyle}>
        {props.children}
      </StyledContent>
    </div>
  );
};

export default ContentLayout;
